import React, { Component } from "react";

class PayerSelect extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    if (this.props.onChange) {
      // The payerCode data attribute is used by the form to determine if the external group ID field
      // should be shown. Currently there is no generic way to tell if this field should be shown, you
      // just have to know which payer you're dealing with. For now we're going to keep using the
      // payer code for this. In the future we should use some sort of flag in the database.
      this.props.onChange(this.valueField(), event.target.value, event.target.selectedOptions[0].dataset.payerCode);
    }
  }

  valueField() {
    return this.props.valueField || "payerId";
  }

  renderSelect() {
    const { payers, allowBlank, blankText, defaultValue } = this.props;

    let options = this.props.payers.map((payer) => {
      return (<option className="payer-option" key={payer.payerId} value={payer.payerId} data-payer-code={payer.payerCode}>{`${payer.payerName} (${payer.payerCode})`}</option>);
    });

    if (this.props.allowBlank) {
      const blankOption = <option className="payer-option" key="blank" value="">{this.props.blankText || ""}</option>;

      options = [blankOption, ...options];
    }

    return (
      <select name={this.valueField()} onChange={this.handleChange} defaultValue={this.props.defaultValue}>
        {options}
      </select>
    );
  }

  render() {
    if (this.props.wrapTableRow) {
      return (
        <tr>
          <th><label htmlFor={this.valueField()}>Payer</label></th>
          <td>
            {this.renderSelect()}
          </td>
        </tr>
      );
    } else {
      return this.renderSelect();
    }
  }
}

export default PayerSelect;
